export default __webpack_public_path__ + "static/media/reactangular_icon.b91ab765.png";